<div class="mobile-content-wrapper">
  <div class="container">
    <div class="tab-container">
      <fgb-tab
        [tabs]="['quiz.tab.live' | translate, 'quiz.tab.results' | translate]"
        (tabSelectionChange)="onTabChage($event)"
      ></fgb-tab>
    </div>

    <div class="mt-3" *ngIf="currentTab === GAME_TAB.LIVE_UPCOMING">
      <button class="btn btn-primary text-white btn-how-it-works" (click)="open()">
        {{ 'quiz.page.how.it.works' | translate }}
      </button>
    </div>
  </div>
  <div class="container mt-4">
    <ng-container *ngIf="gamesGroup$ | async as gamesGroup; else shimmerEffect">
      <ng-container *ngIf="gamesGroup.length > 0; else noGame">
        <fgbcl-games-group-list
          [gamesGroup]="gamesGroup"
          [groupType]="groupType"
          [filters]="filters"
          [sort]="sort"
          [default]="false"
        ></fgbcl-games-group-list>
      </ng-container>
    </ng-container>
  </div>

  <ng-template #shimmerEffect>
    <div class="row">
      <div class="col-12 col-lg-4 mb-4" *ngFor="let i of [1, 2, 3]">
        <div class="card" aria-hidden="true">
          <svg
            class="bd-placeholder-img card-img-top"
            width="100%"
            height="154"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label="Placeholder"
            preserveAspectRatio="xMidYMid slice"
            focusable="false"
          >
            <title>Placeholder</title>
            <rect width="100%" height="100%" fill="#181818"></rect>
          </svg>
          <div class="card-body d-flex flex-column justify-content-between">
            <div>
              <h6 class="card-title placeholder-glow">
                <span class="placeholder col-6"></span>
              </h6>
              <p class="card-text placeholder-glow mb-4">
                <span class="placeholder col-7"></span>
              </p>
            </div>
            <button class="btn btn-primary disabled placeholder w-100"></button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #noGame>
    <div class="d-flex align-items-center justify-content-center no-game-card no-items no-results-placeholder-div">
      <div class="no-results-placeholder">{{ 'fgbcl.game.no.trivia.game.available.text' | translate }}</div>
    </div>
  </ng-template>
</div>
